import './styles/admin-vue-kit.css';
import AdminIslandShell from './components/AdminIslandShell.vue';
import AdminIslandPanel from './components/AdminIslandPanel.vue';
import AdminDataTable from './components/AdminDataTable.vue';
import AdminStatusPill from './components/AdminStatusPill.vue';
import AdminDialog from './components/AdminDialog.vue';

export { default as adminFetch } from './lib/adminFetch';
export { default as adminAlert } from './lib/adminAlert';

export default function registerAdminPanelVueKit(app) {
    app.component('admin-island-shell', AdminIslandShell);
    app.component('admin-island-panel', AdminIslandPanel);
    app.component('admin-data-table', AdminDataTable);
    app.component('admin-status-pill', AdminStatusPill);
    app.component('admin-dialog', AdminDialog);
}
